<template>
  <v-container>
    <div class="title-icon">
      <h1>{{ $t('ebook.create-report') }}</h1>
      <v-btn icon :href="links.ebook.apprenticeInfo" target="_blank">
        <v-icon>$sl-question</v-icon>
      </v-btn>
    </div>
    
    <template v-if="reports.length > 0">
      <h4>{{ $t('ebook.create-report-subtitle1') }}</h4>
      <p>{{ $t('ebook.create-report-subtitle') }}</p>

      <div class="title-icon mt-11">
        <h5>{{ $t('ebook.report-draft') }}</h5>
        <v-icon @click="openDeleteModal=true">$sl-delete</v-icon>
      </div>

      <v-expand-transition>
        <v-card>
          <v-list two-line>
            <v-list-item-group>
              <template v-for="(item,index) in reports">
                <v-divider :key="`divider-${index}`" v-if="index"></v-divider>
                <v-list-item
                  :key="`emp-${index}`"
                  @click="$nextTick(()=>{$router.push({name: 'EbookReportNew',params: { id: Number($route.params.id), reportId: item.id } })})"
                >
                  <v-list-item-avatar>
                    <v-icon>$sl-notes</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>{{$t('ebook.draft')}}</v-list-item-title>
                    <v-list-item-subtitle>{{$t('ebook.created')}} {{item.createdAt | dateFormat}}</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-icon>$sl-arrow-right</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-expand-transition>
    </template>
    <h4 class="mt-12">{{ $t('ebook.new-report') }}</h4>
    <ActionButton
      class
      actionIcon="$sl-note-add"
      @click="$nextTick(()=>{$router.push({name: 'EbookReportNew', params: {id: Number($route.params.id), reportId: -1} })})"
      :isDisabled="isImitatingUser()"
    >
      {{$t('ebook.create-new-report')}}
      
    </ActionButton>
    <v-dialog persistent v-model="openDeleteModal" max-width="700px">
      <EbookReportDeleteModal :reports="reports" @close="closeDeleteModal"></EbookReportDeleteModal>
    </v-dialog>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import API from '@/services/api.js'
import findIndex from 'lodash/findIndex'
import ActionButton from '@/components/Common/ActionButton'
import EbookReportDeleteModal from '@/components/Ebook/Apprentice/EbookReportDeleteModal'

const SugarDate = require('sugar/date')
// @group Ebook
// Styled ReportElementStart component
export default {
  name: 'ReportElementStart',

  components: {
    ActionButton,
    EbookReportDeleteModal
  },

  data: () => ({
    links: require('../../lib/external-links.json'),
    reports: [],
    currentReport: {},
    openDeleteModal: false
  }),

  created() {
    this.init()
  },

  watch: {},

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isApprentice', 'isInstructor', 'isImitatingUser'])
  },

  filters: {
    dateFormat(date) {
      if (date && date != '') return SugarDate.Date(date).format('%Y-%m-%d %H:%M')
      else {
        return ''
      }
    },
    shortDateFormat(date) {
      if (date && date != '') return SugarDate.Date(date).format('%Y-%m-%d')
      else {
        return ''
      }
    }
  },
  methods: {
    init() {
      if (!(this.$route.params.id || Number(this.$route.params.id) > 0)) {
        this.$router.push('/').catch(() => {});
      }
      if (this.currentUser && this.currentUser.books && this.currentUser.books.length > 0) {
        API.listReports({
          bookId: Number(this.$route.params.id),
          startAt: 0,
          pageSize: 100,
          status: 'draft'
        })
          .then(response => {
            this.reports = response.data.rows
            //console.log('rep::', this.reports)
          })
          .catch(error => {
            console.log('There was an error:', error)
          })
      }

    },
    closeDeleteModal(params) {
      if (params && params.bookId && params.reportId) {
        API.deleteReport(params.bookId, params.reportId)
          .then(response => {
            const idx = findIndex(this.reports, ['id', params.reportId])
            if (idx > -1) {
              this.reports.splice(idx, 1)
            }

            this.$events.fire('showInfo', this.$t('success.deleted'))
          })
          .catch(error => {
            this.$events.fire('showError', this.$t('errors.delete-failure'))
            console.log('There was an error:', error)
          })
      }
      this.openDeleteModal = false
    }
  }
}
</script>

